import type { AdminJsonComponentConfig } from '@apps/websiteCustomJsonComponents/JsonComponent.types';
import { loadable } from '@shared/core/loadableFromNamedExport';
import { EventDetailsGrabber } from './components/EventDetailsGrabber';
import { EVENT_DETAILS_SCHEMA_URL, EVENT_DETAILS_COMPONENT_TYPE } from './EventDetails.constants';

// Lazy load view components
const EventDetailsAdd = loadable(() => import(/* webpackChunkName: "content/websiteEditorEventDetailsAdd" */ './components/EventDetailsAdd'), 'EventDetailsAdd');

const EventDetailsEdit = loadable(() => import(/* webpackChunkName: "content/websiteEditorEventDetailsEdit" */ './components/EventDetailsEdit'), 'EventDetailsEdit');

// Add this object to CUSTOM_JSON_COMPONENT_TYPES in
// src/apps/websiteCustomJsonComponents/config.ts
export const EventDetailsConfig: AdminJsonComponentConfig = {
  schemaUrl: EVENT_DETAILS_SCHEMA_URL,
  componentType: EVENT_DETAILS_COMPONENT_TYPE,
  adminSidebarComponent: {
    addComponentView: EventDetailsAdd,
    dragComponentView: EventDetailsGrabber,
    editComponentView: EventDetailsEdit,
    createComponentView: EventDetailsEdit,
  },
} as const;
